import { Image } from "react-native-web";

export default {
    getSize: imgSrc => {
        return new Promise((resolve, reject) => {
            Image.getSize(
                imgSrc,
                (width, height) => {
                    resolve({ width, height });
                },
                () => {
                    reject();
                }
            );
        });
    },
};
